import React, { useEffect, useRef } from 'react';
import { IconButton } from '@icecreamsocial/components';
import { FacebookIcon } from '../SupportedIcons';

export const FacebookButton = ({
	locale = 'en-US',
	xfbml = true,
	status = true,
	link,
	...rest
}) => {
	const MAX_TRIES = 3;
	const VERSION = process.env.FB_SDK_VERSION;
	const APP_ID = process.env.FB_APP_ID;
	const tryRef = useRef({ tries: MAX_TRIES });
	// load the fb script
	useEffect(() => {
		const scriptId = 'ics-fb-sdk';
		const alreadyLoaded = document.getElementById(scriptId);
		if (!alreadyLoaded) {
			const fb = document.createElement('script');
			fb.id = scriptId;
			fb.src = `//connect.facebook.net/${locale}/sdk.js`;
			fb.async = true;
			fb.onload = initFB;
			document.body.appendChild(fb);
		}
	}, []);

	// call once loaded
	const initFB = () => {
		const { FB } = window;

		if (FB) {
			// initialize the client
			FB.init({
				autoLogAppEvents: true,
				appId: APP_ID,
				version: VERSION,
				xfbml,
				status,
			});
			FB.AppEvents.logPageView();
			console.log('FB loaded');
		} else if (tryRef.current.tries-- !== 0) {
			console.log('FB is not yet available. retrying');
			// retry after 500ms
			return setTimeout(() => initFB(), 500);
		} else {
			console.error('Exceded retries for FB');
			return;
		}
	};

	const share = () => {
		const { FB } = window;

		if (FB) {
			FB.ui(
				{
					method: 'share',
					href: link,
					locale,
				},
				(response) => {
					console.info(response);
				}
			);
		}
	};

	return (
		<IconButton
			backgroundColor='#1778f2'
			textColor='bodyInverse'
			onClick={share}
			{...rest}
		>
			<IconButton.Icon as={FacebookIcon} />
			<IconButton.Text typoSize='1.1em'>Facebook</IconButton.Text>
		</IconButton>
	);
};
